import { actionDuckUtils } from 'wanderu-ducks-utils';

import sliceNamespace from '../../types';
import { serializeSearchParams } from '../utils';

const namespace = 'FETCH_CACHED_TRIPS';
const {
    actions,
    reducer,
    selectors,
} = actionDuckUtils.buildBaseDuck(namespace, sliceNamespace, serializeSearchParams);

export {
    actions,
    namespace,
    reducer,
    selectors,
};
